import { useTranslation } from 'react-i18next'
import iconEvent from 'assets/images/eventBunpimay/iconTextEvent.png'
import iconPhone from 'assets/images/eventBunpimay/samsung-galaxy-a05s.png'
import iconMinute from 'assets/images/eventBunpimay/minutes.png'
import iconMoney from 'assets/images/eventBunpimay/money.png'
import iconHeadphone from 'assets/images/eventBunpimay/headphone.png'
import iconMB from 'assets/images/eventBunpimay/MB.png'
function EventBunpimayHome({ setTabActive }) {
	const { t } = useTranslation()
	const listReward = [
		{
			id: 1,
			icon: iconPhone,
		},
		{
			id: 2,
			icon: iconMinute,
		},
		{
			id: 3,
			icon: iconMoney,
		},
		{
			id: 4,
			icon: iconHeadphone,
		},
		{
			id: 5,
			icon: iconMB,
		},
	]
	return (
		<div className="box-info">
			<div className="box-info-description">
				<img draggable="false" className="icon-event" srcSet={`${iconEvent} 2x`} />

				{listReward.map(item => (
					<div
						className={`box-prize-home prize_${item.id}`}
						key={`item_reward_${item.id}`}
					>
						<img draggable="false" className="box-prize-home-img" src={item.icon} />
					</div>
				))}
			</div>
			<span className="description">
				{t('event.bunpimay.homepage.description')}
			</span>
			<button onClick={() => setTabActive("COLLECT")} className="btn btn-bunpimay">
				<span>{t('event.bunpimay.homepage.collect_now')}</span>
			</button>
		</div>
	)
}

export default EventBunpimayHome
